// extracted by mini-css-extract-plugin
export default {"cards":"Cards-module_cards__EBzOh"};